module.exports = __webpack_public_path__ + "static/media/things-we-do.a2eab70d.webp";